import { Link } from "react-router-dom";
import { useLang, useLp } from "../lib/i18n";
import {
  currentSourcePage,
  trackDownloadClick,
  trackSignupClick,
} from "../lib/plausible";
import { blogPostChromeCopy } from "../lib/translations/pages/blog";

export function BlogPostCta() {
  const lang = useLang();
  const lp = useLp();
  const copy = blogPostChromeCopy[lang].cta;

  return (
    <aside className="mt-16 border-y border-margin bg-graphite/[0.025] px-5 py-10 dark:border-paper/10 dark:bg-paper/[0.035] sm:px-8">
      <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink/55 dark:text-paper/55">
        {copy.eyebrow}
      </p>
      <h2 className="mt-4 max-w-2xl font-display text-3xl font-semibold tracking-tight text-ink dark:text-paper sm:text-4xl">
        {copy.heading}
      </h2>
      <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-ink/75 dark:text-paper/75">
        {copy.body}
      </p>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Link
          to={lp + "/?auth=signup&plan=free"}
          onClick={() =>
            trackSignupClick({
              source_page: currentSourcePage(),
              lang,
              plan: "free",
            })
          }
          className="inline-flex min-h-12 items-center justify-center rounded-full bg-ink px-6 py-3 text-sm font-medium text-paper transition-colors hover:bg-ink/90 dark:bg-paper dark:text-ink dark:hover:bg-paper/90"
        >
          {copy.primary}
        </Link>
        <Link
          to={lp + "/downloads"}
          onClick={() =>
            trackDownloadClick({
              source_page: currentSourcePage(),
              lang,
              os: "unknown",
            })
          }
          className="inline-flex min-h-12 items-center justify-center rounded-full border border-ink/15 px-6 py-3 text-sm font-medium text-ink transition-colors hover:bg-ink/5 dark:border-paper/20 dark:text-paper dark:hover:bg-paper/5"
        >
          {copy.secondary}
        </Link>
        <Link
          to={lp + "/use-cases/ai-meeting-copilot"}
          className="inline-flex min-h-12 items-center justify-center px-1 text-sm font-medium text-ink/70 underline decoration-ink/25 underline-offset-4 transition-colors hover:text-ink hover:decoration-ink dark:text-paper/70 dark:decoration-paper/25 dark:hover:text-paper dark:hover:decoration-paper sm:px-3"
        >
          {copy.tertiary}
        </Link>
      </div>

      <p className="mt-5 text-xs leading-relaxed text-ink/55 dark:text-paper/55">
        {copy.proof}
      </p>
    </aside>
  );
}
